module.exports = __webpack_public_path__ + "static/media/glacialindifference-regular-webfont.0542887b.woff2";